<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" label-width="70px">
        <el-form-item label="QY工号">
          <el-input v-model.trim="form.workNo"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model.trim="form.userName"></el-input>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="form.storeName" placeholder="请选择">
            <el-option
              v-for="item in authOptionsList"
              :key="item.storeName"
              :label="item.storeName"
              :value="item.storeName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="add">新增</el-button>
      </template>
      <el-table 
        :data="tableData.list" 
        border 
        :height="maxTableHeight" 
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column label="QY工号" prop="workNo" width="120px" show-overflow-tooltip></el-table-column>
        <el-table-column label="姓名" prop="userName" width="120px" show-overflow-tooltip></el-table-column>
        <el-table-column label="店铺权限" prop="storeName" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新人" prop="updatedPerson" width="120px"></el-table-column>
        <el-table-column label="更新时间" prop="updatedDate" width="200px"></el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- dialog -->
    <v-dialog v-model="dialogVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
      <div slot="content">
        <add-edit ref="content" :data="rowData" :authOptions="adialogAuthOptions" v-if="dialogVisible"></add-edit>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import addEdit from './components/add&edit/add&edit'
import tableMixin from '@/utils/tableMixin'

export default {
  components: { addEdit },
  mixins: [tableMixin],
  data() {
    return {
      form: {
        storeName: '全部'
      },
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      dialogConfig: {},
      rowData: {},
      authOptionsList: [],
      adialogAuthOptions: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    }
  },
  mounted() {
    this.$set(this.form, 'storeId', '')
    this.onSearch();
    this.clearStockConfigStoreList()
    this.clearStockConfigStoreUpdateList()
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1
      this.init()
    },
    async init() {
      this.loading = true
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: 'clearStockStoreUserList',
        param: {
          storeName: this.form.storeName == '全部' ? null : this.form.storeName,
          workNo: this.form.workNo,
          userName: this.form.userName
        },
        queryMatch: [],
        orderList: [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y'
      }
      axios.post(`/ec-pc-api/custom/reports/data/clearStockStoreUserList`, data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).finally(() => {
        this.loading = false
      });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30
      this.form = {
        storeName: '全部'
      }
      this.$set(this.form, 'storeId', '')
      this.init();
    },
    clearStockConfigStoreList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm))
      currencyForm.reportCode = 'clearStockConfigStoreList'
      axios.post(`/ec-pc-api/custom/reports/data/clearStockConfigStoreList`, currencyForm).then(res => {
        if (res.code == 200) {
          this.authOptionsList = res.data.list
        }
      })
    },
    clearStockConfigStoreUpdateList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm))
      currencyForm.reportCode = 'clearStockConfigStoreUpdateList'
      axios.post(`/ec-pc-api/custom/reports/data/clearStockConfigStoreUpdateList`, currencyForm).then(res => {
        if (res.code == 200) {
          this.adialogAuthOptions = res.data.list
        }
      })
    },
    // 新增 弹出dialog
    add() {
      this.dialogConfig = {
        title: '新增',
        width: '40%',
        confirmCallback: true
      };
      this.rowData = {};
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.dialogConfig = {
        title: '编辑',
        width: '40%',
        confirmCallback: true
      };
      this.rowData = row;
      this.dialogVisible = true;
    },
    // 弹窗 确认事件
    async dialogConfirm() {
      let type = JSON.stringify(this.rowData) === '{}'
      let text = type ? '新增' : '编辑'
      let formData = this.$refs['content'].formData;
      if (!formData.userId) {
        this.$message.error('用户不能为空')
        return
      } else if (!formData.storeCodeList || !formData.storeCodeList.length) {
        this.$message.error('店铺不能为空')
        return
      }
      let data = {
        dataId: !type ? this.rowData.dataId : '',
        storeCodeList: formData.storeCodeList || [],
        userId: formData.userId || ''
      }
      let res = await this.$q.clearanceManagement.saveOrUpdate({ data: data })
      if (res.success) {
        this.$message.success(`${text}成功`)
      } else {
        this.$message.fail(`${text}失败`)
      }
      this.dialogVisible = false;
      this.init();
    },
    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let res = await this.$q.clearanceManagement.storeUserDel({ fragment: [row.userId] })
      if (res.success) {
        this.$message.success('删除成功')
      } else {
        this.$message.fail('删除失败')
      }
      this.init();
    }
  },
}
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.footerBox
  text-align right
</style>
